import React, { useState } from 'react';

import trim from 'lodash/trim';

import { SearchInput } from '@gogame/components';

const SearchField = ({ onChange }) => {
  const [value, setValue] = useState('');

  const handleChange = (e, value) => {
    setValue(value);
    onChange(e, trim(value));
  };

  return (
    <SearchInput
      fullWidth={true}
      value={value}
      onChange={handleChange}
      debounceTimeout={300}
    />
  );
};

export default SearchField;
